import { render, staticRenderFns } from "./LocationAdding.vue?vue&type=template&id=b89697ac&"
import script from "./LocationAdding.vue?vue&type=script&lang=js&"
export * from "./LocationAdding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports